<template>
  <div data-app>
    <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
      <span>
        <template v-if="snackbar.icon">
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>
      <md-button
        class="md-primary md-simple md-dense"
        @click="snackbar.show = false">Dismiss</md-button>
    </md-snackbar>
    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content"/>
    <group-card title="Documents Uploaded" icon="cloud" padded>

      <md-tabs
        md-dynamic-height
        @md-changed="checkCurrentTab"
      >
      <md-tab id="documents" md-label="Documents">
        <v-data-table
          :headers="documentheaders"
          :items="uploadedDocumentsWithoutBankStatement"
          class="elevation-0 document_table"
          :loading="isEditing"
          :loading-text="loading_text"
        >
          <template v-slot:header.action>
           <md-checkbox v-model="documentSelectAll" @change="selectAllCheckbox('documents')">Action</md-checkbox>
          </template>
          <template v-slot:item.applicant="{ item }">
           {{ item.applicant | name }}
          </template>
          <template v-slot:item.action="{ item }">
              <md-checkbox @change="masterCheckUncheck(selected_documents[item.id], 'documents')" v-model="selected_documents[item.id]"></md-checkbox>
          </template>
          <template v-slot:item.document_type="{ item }">
            <v-edit-dialog
                    :return-value.sync="item.document_type"
                    large
                    @save="editDocumentType(item)"
                    v-if="update_doc_type_permission"
                    > {{item.document_type}}
                        <md-icon class="md-primary">edit</md-icon>
                        <template v-slot:input>
                            <v-select
                                v-model="item.document_type"
                                :items="options.document_types"
                            ></v-select>
                        </template>
                    </v-edit-dialog>
                    <span v-else>
                        {{item.document_type}}
                    </span>
          </template>
          <template v-slot:item.file_name="{ item }">
              {{ item.file_name }}
          </template>
          <template v-slot:item.created_at="{ item }">
              {{ item.created_at | datetime }}
          </template>
          <template v-slot:item.verify="{ item }">
             <md-checkbox class="md-layout-item md-small-size-50 md-size-10"
                                v-model="item.verified"
                    >Verify</md-checkbox>
          </template>
          <template v-slot:item.download="{ item }" v-if="download_permission">
                      <a :href="item.view_url" target="_blank" :disabled="item.url == null" :class="{disabled: item.url == null}">
                      <md-tooltip md-direction="top">Open in new tab</md-tooltip>
                      <md-icon class="md-primary">open_in_new</md-icon>
                      </a>

                      <a :href="item.url" :disabled="item.url == null" :class="{disabled: item.url == null}">
                      <md-tooltip md-direction="top">Download</md-tooltip>
                      <md-icon class="md-primary">download</md-icon>
                      </a>
                    <md-button class="md-just-icon md-primary md-simple" @click="decline(item)" >
                    <md-icon>close</md-icon>
                    <md-tooltip md-direction="top">Delete</md-tooltip>
                  </md-button>
                   </template>
        </v-data-table>

          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <md-button class="md-primary md-sm" @click="submit_docusign">Docusign</md-button>
              <md-button class="md-primary md-sm" @click="submit_email_customer">Email to Customer</md-button>
              <md-button class="md-primary md-sm" @click="submit_email_lender" :disabled="!hasPreviousSubmission">Email to Lender</md-button>
              <md-button class="md-primary md-sm" @click="download_as_zip()">Download All</md-button>
              <span class="loading_icon_position">
                <md-progress-spinner
                  :md-diameter="17"
                  :md-stroke="2"
                  v-show="sending_document"
                  md-mode="indeterminate"
                  class="no-fade-out"
                />
              </span>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-20 md-alignment-right">
              <md-button class="md-primary md-sm" @click="save_verify">
                Save Verify
              </md-button>
              <span class="loading_icon_position">
                <md-progress-spinner
                  :md-diameter="17"
                  :md-stroke="2"
                  v-show="sending_email"
                  md-mode="indeterminate"
                  class="no-fade-out"
                />
              </span>
            </div>
          </div>
        </md-tab>

        <md-tab id="bankstatement" md-label="Bank Statements">
          <v-data-table
            :headers="documentheaders"
            :items="uploadedDocumentsBankStatement"
            class="elevation-0 document_table"
            :loading="isEditing"
            :loading-text="loading_text"
          >
          <template v-slot:header.action>
            <md-checkbox v-model="uploadedSelectAll" @change="selectAllCheckbox('uploadedDocuments')">Action</md-checkbox>
          </template>
          <template v-slot:item.applicant="{ item }">
            {{ item.applicant | name }}
          </template>
          <template v-slot:item.action="{ item }">
              <md-checkbox  @change="masterCheckUncheck(selected_documents[item.id], 'uploadedDocuments')" v-model="selected_documents[item.id]"></md-checkbox>
          </template>
          <template v-slot:item.document_type="{ item }">
            {{ item.document_type }}
          </template>
          <template v-slot:item.file_name="{ item }">
              {{ item.file_name }}
          </template>
          <template v-slot:item.created_at="{ item }">
              {{ item.created_at | datetime }}
          </template>
          <template v-slot:item.verify="{ item }">
               <md-checkbox class="md-layout-item md-small-size-50 md-size-10"
                             v-model="item.verified"
                >Verify</md-checkbox>
          </template>
          <template v-slot:item.download="{ item }" v-if="download_permission">
             <a :href="item.view_url" target="_blank" :disabled="item.url == null" :class="{disabled: item.url == null}">
                    <md-tooltip md-direction="top">Open in new tab</md-tooltip>
                    <md-icon class="md-primary">open_in_new</md-icon>
                    </a>

                    <a :href="item.url" :disabled="item.url == null" :class="{disabled: item.url == null}">
                    <md-tooltip md-direction="top">Download</md-tooltip>
                    <md-icon class="md-primary">download</md-icon>
                    </a>
                    <md-button class="md-just-icon md-primary md-simple" @click="decline(item)" >
                    <md-icon>close</md-icon>
                    <md-tooltip md-direction="top">Delete</md-tooltip>
                  </md-button>
          </template>
        </v-data-table>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-70">
              <md-button class="md-primary md-sm" @click="submit_docusign" :disabled="!enableDocusignBasedOnRole">Docusign</md-button>
              <md-button class="md-primary md-sm" @click="submit_email_customer">Email to Customer</md-button>
              <md-button class="md-primary md-sm" @click="submit_email_lender" :disabled="!hasPreviousSubmission">Email to Lender</md-button>
              <md-button class="md-primary md-sm" @click="download_as_zip()">Download All</md-button>
              <span class="loading_icon_position">
                <md-progress-spinner
                  :md-diameter="17"
                  :md-stroke="2"
                  v-show="sending_document"
                  md-mode="indeterminate"
                  class="no-fade-out"
                />
              </span>
            </div>

          <div class="md-layout-item md-small-size-100 md-size-20 md-alignment-right">
          <md-button class="md-primary md-sm" @click="save_verify_bankstatement">
            Save Verify
          </md-button>
            <span class="loading_icon_position">
              <md-progress-spinner
                :md-diameter="17"
                :md-stroke="2"
                v-show="sending_email"
                md-mode="indeterminate"
                class="no-fade-out"
              />
            </span>
          </div>
        </div>
        </md-tab>

        <md-tab id="generated-documents" md-label="Generated Documents">
          <v-data-table
            :headers="documentheaders"
            :items="generatedDocuments"
            class="elevation-0 document_table"
            :loading="isEditing"
            :loading-text="loading_text"
          >
          <template v-slot:header.action>
            <md-checkbox v-model="generatedDocSelectAll" @change="selectAllCheckbox('generatedDocuments')">Action</md-checkbox>
          </template>
          <template v-slot:item.applicant="{ item }">
            {{ item.applicant | name }}
          </template>
          <template v-slot:item.action="{ item }">
              <md-checkbox  @change="masterCheckUncheck(selected_documents[item.id], 'generatedDocuments')" v-model="selected_documents[item.id]"></md-checkbox>
          </template>
          <template v-slot:item.document_type="{ item }">
            {{ item.document_type }}
          </template>
          <template v-slot:item.file_name="{ item }">
              {{ item.file_name }}
          </template>
          <template v-slot:item.created_at="{ item }">
              {{ item.created_at | datetime }}
          </template>
          <template v-slot:item.verify="{ item }">
              <md-checkbox class="md-layout-item md-small-size-50 md-size-10" v-model="item.verified">Verify</md-checkbox>
          </template>
          <template v-slot:item.download="{ item }" v-if="download_permission">
            <a :href="item.view_url" target="_blank" :disabled="item.url == null" :class="{disabled: item.url == null}">
                    <md-tooltip md-direction="top">Open in new tab</md-tooltip>
                    <md-icon class="md-primary">open_in_new</md-icon>
                    </a>

                    <a :href="item.url" :disabled="item.url == null" :class="{disabled: item.url == null}">
                    <md-tooltip md-direction="top">Download</md-tooltip>
                    <md-icon class="md-primary">download</md-icon>
                    </a>
                    <md-button class="md-just-icon md-primary md-simple" @click="decline(item)" >
                    <md-icon>close</md-icon>
                    <md-tooltip md-direction="top">Delete</md-tooltip>
                  </md-button>
          </template>
        </v-data-table>

          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <md-button class="md-primary md-sm" @click="submit_docusign">Docusign</md-button>
              <md-button class="md-primary md-sm" @click="submit_email_customer">Email to Customer</md-button>
              <md-button class="md-primary md-sm" @click="submit_email_lender" :disabled="!hasPreviousSubmission">Email to Lender</md-button>
              <md-button class="md-primary md-sm" @click="download_as_zip">Download All</md-button>
              <span class="loading_icon_position">
                <md-progress-spinner
                  :md-diameter="17"
                  :md-stroke="2"
                  v-show="sending_document"
                  md-mode="indeterminate"
                  class="no-fade-out"
                />
              </span>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-20 md-alignment-right">

              <span class="loading_icon_position">
                <md-progress-spinner
                  :md-diameter="17"
                  :md-stroke="2"
                  v-show="sending_email"
                  md-mode="indeterminate"
                  class="no-fade-out"
                />
              </span>
            </div>
          </div>

        </md-tab>

        <md-tab id="deleted-documents" md-label="Deleted Documents" v-if="userHasPermission('view deleted-documents')">
          <md-table v-model="deletedDocuments">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Applicant" md-sort-by="applicant">{{ item.applicant | name }}</md-table-cell>
              <md-table-cell md-label="Document Type" md-sort-by="document_type">{{ item.document_type }}</md-table-cell>
              <md-table-cell md-label="File Name" md-sort-by="file_name">{{ item.file_name }}</md-table-cell>
              <md-table-cell md-label="Deleted At" md-sort-by="file_name">{{ item.deleted_at | datetime }}</md-table-cell>
              <md-table-cell md-label="Actions" v-if="download_permission">
                <div>
                    <a :href="item.view_url" target="_blank" :disabled="item.url == null" :class="{disabled: item.url == null}">
                    <md-tooltip md-direction="top">Open in new tab</md-tooltip>
                    <md-icon class="md-primary">open_in_new</md-icon>
                    </a>

                    <a :href="item.url" :disabled="item.url == null" :class="{disabled: item.url == null}">
                    <md-tooltip md-direction="top">Download</md-tooltip>
                    <md-icon class="md-primary">download</md-icon>
                    </a>
                    <md-button class="md-just-icon md-primary md-simple" @click="decline(item)" >
                    <md-icon>close</md-icon>
                    <md-tooltip md-direction="top">Delete</md-tooltip>
                  </md-button>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-tab>

        <!-- Start: Signed Documents -->
        <md-tab id="signed-documents" md-label="Signed Documents">
          <md-table v-model="signedDocuments">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Applicant" md-sort-by="applicant">{{ item.applicant | name }}</md-table-cell>
              <md-table-cell md-label="Document Type" md-sort-by="document_type">{{ item.document_type }}</md-table-cell>
              <md-table-cell md-label="File Name" md-sort-by="file_name">{{ item.file_name }}</md-table-cell>
              <md-table-cell md-label="Created At" md-sort-by="created_at">{{ item.created_at | datetime }}</md-table-cell>
              <md-table-cell md-label="Actions" v-if="download_permission">
                <div>
                    <a :href="item.view_url" target="_blank" :disabled="item.url == null" :class="{disabled: item.url == null}">
                    <md-tooltip md-direction="top">Open in new tab</md-tooltip>
                    <md-icon class="md-primary">open_in_new</md-icon>
                    </a>

                    <a :href="item.url" :disabled="item.url == null" :class="{disabled: item.url == null}">
                    <md-tooltip md-direction="top">Download</md-tooltip>
                    <md-icon class="md-primary">download</md-icon>
                    </a>
                    <md-button class="md-just-icon md-primary md-simple" @click="decline(item)" >
                    <md-icon>close</md-icon>
                    <md-tooltip md-direction="top">Delete</md-tooltip>
                  </md-button>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-tab>
        <!-- End : Signed Documents -->

        <!-- Start: DocuSign Envelopes -->
        <md-tab id="signed-in-progress" md-label="DocuSign Envelopes">
          <v-data-table
            :headers="signedInProgressHeaders"
            :items="envelopesProgressItems"
            class="elevation-0 document_table"
            :loading="isEditing"
            :loading-text="loading_text"
          >
            <template v-slot:item.documents="{ item }">
              <div v-html="listOfDocuments(item)"></div>
            </template>
            <template v-slot:item.signers="{ item }">
              <div v-html="listOfSigners(item)"></div>
            </template>
            <template v-slot:item.status="{ item }">
                <p><strong>System Status:</strong> {{ getStatus(item) }}</p>
                <p v-if="hasHistory(item)"><strong>DocuSign Status:</strong> {{ getHistoryLatestStatus(item).status }}</p>
                <p v-if="hasHistory(item)"><strong>Action:</strong> {{ getHistoryLatestStatus(item).action }}</p>
                <p v-if="hasHistory(item)"><strong>Time:</strong> {{ getHistoryLatestStatus(item).time }}</p>
            </template>
            <template v-slot:item.actions="{ item }">
                <md-button class="md-just-icon md-primary md-simple" @click="openViewHistoryDialog(item)" :class="{disabled: !hasHistory(item)}">
                    <md-icon>open_in_new</md-icon>
                    <md-tooltip md-direction="top">View History</md-tooltip>
                </md-button>
                <md-button class="md-just-icon md-primary md-simple" @click="openResendEnvelopeDialog(item)" :class="{disabled: checkEnvelopeStatus(item)}">
                    <md-icon>forward_to_inbox</md-icon>
                    <md-tooltip md-direction="top">Resend</md-tooltip>
                </md-button>
                <md-button class="md-just-icon md-primary md-simple" @click="openVoidEnvelopeDialog(item)" :class="{disabled: checkEnvelopeStatus(item)}">
                    <md-icon>close</md-icon>
                    <md-tooltip md-direction="top">Void</md-tooltip>
                </md-button>
          </template>
          </v-data-table>
        </md-tab>
        <!-- End : DocuSign Envelopes -->
      </md-tabs>

    </group-card>
    <!-- History Dialog -->
    <md-dialog class="md-layout" :md-active.sync="viewHistoryDialog">
        <div class="wrapper_no_width">
            <div>
                <h4>History for Envelope {{ viewHistoryEnvelope.id }}</h4>
            </div>

            <div md-card class="view_histroy_dialog" style="display: flex">
                <v-data-table
                    :headers="viewHistoryHeaders"
                    :items="viewHistoryEnvelope.items"
                    class="elevation-0 document_table"
                    loading
                    :loading-text="loading_text"
                ></v-data-table>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary md-simple" @click="onCloseHistoryDialog"> Close </md-button>
            </md-dialog-actions>
        </div>
    </md-dialog>
    <!-- Resend Envelope Dialog -->
    <md-dialog class="md-layout" :md-active.sync="resendEnvelopeDialog">
        <div class="wrapper">
            <div>
                <h4>Are you sure you want to resend docuSign envelope?</h4>
            </div>
            <md-dialog-actions class="resend">
                <md-button class="md-primary md-simple" @click="onCloseResendEnvelopeDialog"> No </md-button>
                <loading-icon-text-button @click="confirmResendEnvelope" icon="save" :loading="sendingResendEnvelopeRequest"> Yes </loading-icon-text-button>
            </md-dialog-actions>
        </div>
    </md-dialog>
    <!-- Void Envelope Dialog -->
    <md-dialog class="md-layout" :md-active.sync="voidEnvelopeDialog">
        <div class="wrapper">
            <div>
                <h4>Why do you wish to void docuSign envelope?</h4>
            </div>

            <div md-card class="void_envelope_dialog" style="display: flex">
                <v-textarea label="Please provide more details" v-model="voidReason" outlined></v-textarea>
            </div>
            <md-dialog-actions>
                <md-button class="md-primary md-simple" @click="onCloseVoidEnvelopeDialog"> Cancel </md-button>
                <loading-icon-text-button @click="confirmVoidEnvelope" icon="save" :loading="sendingVoidEnvelopeRequest"> Confirm </loading-icon-text-button>
            </md-dialog-actions>
        </div>
    </md-dialog>
    <md-dialog-alert
        :md-active.sync="error_dialog.show"
        :md-title="error_dialog.title"
        :md-content="error_dialog.content"
      />
  </div>
</template>

<script>
import { GroupCard } from "@/components";
import {mapGetters} from 'vuex';
import filters from "../utils/filters";
import { IconCheckbox } from "@/components";
import ConfirmDialog from "../Dialogs/ConfirmDialog";
import LoadingIconTextButton from '@/components/LoadingIconTextButton'

export default {
  components: {
    GroupCard,
    IconCheckbox,
    ConfirmDialog,
    LoadingIconTextButton
  },
  data(){
    return{
      documentSelectAll: false,
      uploadedSelectAll: false,
      generatedDocSelectAll:false,
      envelopesProgressItems: [],
      documentheaders: [
        {text: 'Applicant', value: 'applicant', sortable: true},
        {text: 'Action', value: 'action', sortable: false},
        {text: 'Document Type', value: 'document_type', sortable: true},
        {text: 'File Name', value: 'file_name', sortable: true},
        {text: 'Created At', value: 'created_at', sortable: true},
        {text: 'Verify', value: 'verify', sortable: false},
        {text: 'Download', value: 'download', sortable: false},
      ],
      signedInProgressHeaders: [
        {text: 'Envelope Id', value: 'docusign_envelope_id', sortable: true},
        {text: 'Document/s in Envelope', value: 'documents', sortable: false},
        {text: 'Signers', value: 'signers', sortable: false},
        {text: 'Latest Status', value: 'status', sortable: false},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      viewHistoryHeaders: [
        {text: 'Action', value: 'Action', sortable: true},
        {text: 'Status', value: 'EnvelopeStatus', sortable: true},
        {text: 'Message', value: 'Message', sortable: true},
        {text: 'Source', value: 'Source', sortable: true},
        {text: 'Date', value: 'logTime', sortable: true},
      ],
      loading_text: this.uploadedDocumentsWithoutBankStatement == null ? "No Records" : "Loading... Please wait",
      allowed_download: false,
      sending_email: false,
      selected_documents: {},
      selectedTab: '',
      sending_document: false,
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      snackbar: {
        show: false,
        icon: "done",
        content: '',
      },
      isEditing: false,
      alertMessage: false,
      message: '',
      loading: false,
      viewHistoryDialog: false,
      viewHistoryEnvelope: {
        id: null,
        items: null
      },
      voidEnvelopeDialog: false,
      selectedVoidEnvelopeId: null,
      voidReason: null,
      sendingVoidEnvelopeRequest: false,
      resendEnvelopeDialog: false,
      selectedResendEnvelopeId: null,
      sendingResendEnvelopeRequest: false,
    }
  },
  created() {
   this.getDocuments();
  },
  methods:{
    hasHistory(envelope)
    {
        return Array.isArray(envelope?.docusign_audit?.history) && envelope.docusign_audit.history.length > 0;
    },
    listOfDocuments(envelope) {
        const documents = envelope?.documents;
        if (!Array.isArray(documents) || documents.length === 0) return null;
        return documents.map(document =>
            `${document.filename} (${document.pivot.signed_document == 1 ? 'signed' : 'unsigned'})</br>`
        ).join('');
    },
    listOfSigners(envelope) {
        const signers = envelope?.docusign_audit?.signers;
        if (!Array.isArray(signers) || signers.length === 0) return null;
        return signers.map(signer => `${signer.name} - (${signer.email})<br>`).join('');
    },
    getHistoryLatestStatus(envelope) {
        const history = envelope.docusign_audit.history;

        // Sort history by logTime descending
        const sortedHistory = history.slice().sort((a, b) => {
            return new Date(b.logTime) - new Date(a.logTime);
        });

        // Return the most recent status
        const latest = sortedHistory[0];
        return {
            action: latest.Action,
            status: latest.EnvelopeStatus,
            user: latest.UserName,
            time: latest.logTime,
            message: latest.Message
        };
    },
    openViewHistoryDialog(envelope) {
        console.log('Open View history');
        this.viewHistoryDialog = true;
        // Open a popup with history oldest to newest
        this.viewHistoryEnvelope.id = envelope.docusign_envelope_id;

        const history = envelope.docusign_audit.history;
        const sortedHistory = history.slice().sort((a, b) => {
            return new Date(a.logTime) - new Date(b.logTime);
        });

        this.viewHistoryEnvelope.items = sortedHistory;
    },
    onCloseHistoryDialog() {
        console.log('Close View history');
        this.viewHistoryDialog = false;
        this.viewHistoryEnvelope.id = null;
        this.viewHistoryEnvelope.items = null;
    },
    openResendEnvelopeDialog(envelope) {
        console.log('Open Resend Envelope');

        // Open a popup with a reason
        this.resendEnvelopeDialog = true;
        this.selectedResendEnvelopeId = envelope.docusign_envelope_id;
    },
    onCloseResendEnvelopeDialog () {
        console.log('Close Resend Envelope');

        // Open a popup with a reason
        this.resendEnvelopeDialog = false;
        this.selectedResendEnvelopeId = null;
    },
    async confirmResendEnvelope() {
        // on submitting in calls the resend envelop api call
        let payload = {
            'application_id': this.application.loan.id,
            'envelope_id': this.selectedResendEnvelopeId,
        }
        this.sendingResendEnvelopeRequest = true;
        // resend specific envelope
        let result = await axios.post(`/api/v1/docusign/resend_envelope`, payload);
        if (result) {
            // fetch envelope list again
            await this.getNotSignedEnvelopes();
            this.sendingResendEnvelopeRequest = false;
            this.onCloseResendEnvelopeDialog();
        } else {
            this.sendingResendEnvelopeRequest = false;
            this.showDialogNotification(result, "Error");
        }
    },
    openVoidEnvelopeDialog(envelope) {
        console.log('Open Void Envelope');

        // Open a popup with a reason
        this.voidEnvelopeDialog = true;
        this.selectedVoidEnvelopeId = envelope.docusign_envelope_id;
    },
    onCloseVoidEnvelopeDialog () {
        console.log('Close Void Envelope');

        // Open a popup with a reason
        this.voidEnvelopeDialog = false;
        this.selectedVoidEnvelopeId = null;
    },
    async confirmVoidEnvelope() {
        // on submitting in calls the void envelop api call
        let payload = {
            'application_id': this.application.loan.id,
            'envelope_id': this.selectedVoidEnvelopeId,
            'void_reason': this.voidReason,
        }
        console.log('void payload', payload);
        this.sendingVoidEnvelopeRequest = true;
        // Void specific envelope
        let result = await axios.post(`/api/v1/docusign/void_envelope`, payload);
        if (result) {
            // fetch envelope list again
            await this.getNotSignedEnvelopes();
            this.sendingVoidEnvelopeRequest = false;
            this.onCloseVoidEnvelopeDialog();
        } else {
            this.sendingVoidEnvelopeRequest = false;
            this.showDialogNotification(result, "Error");
        }
    },
    getStatus(envelope) {
        return envelope?.docusign_status?.description ?? null;
    },
    checkEnvelopeStatus(envelope) {
        const status = this.getStatus(envelope);
        return status === 'completed' || status === 'voided';
    },
    selectAllCheckbox: function (type) {
      if (type == 'documents') {
        var selectAll = this.documentSelectAll;
        var dataArr =  this.uploadedDocumentsWithoutBankStatement;
      } else if (type == 'uploadedDocuments') {
        var selectAll = this.uploadedSelectAll;
        var dataArr =  this.uploadedDocumentsBankStatement;
      } else if (type == 'generatedDocuments') {
        var selectAll = this.generatedDocSelectAll;
        var dataArr = this.generatedDocuments;
      }
      if (selectAll) {
          var obj = {};
          dataArr.map(docs => {
            let id = docs.id;
            obj[id] = true;
          });
          this.selected_documents = obj;
      } else {
         var obj = {};
          dataArr.map(docs => {
            let id = docs.id;
              if(docs.id !== undefined) {
                obj[docs.id] = false;
              }
          });
          this.selected_documents = obj;
      }
    },
    masterCheckUncheck(checkValue, type){
      if (type == 'documents') {
        var documentArr =  this.uploadedDocumentsWithoutBankStatement;
      } else if (type == 'uploadedDocuments') {
        var documentArr =  this.uploadedDocumentsBankStatement;
      } else if (type == 'generatedDocuments') {
        var documentArr = this.generatedDocuments;
      }
      if (checkValue == false) {
        if (type == 'documents') {
          this.documentSelectAll = false;
        } else if (type == 'uploadedDocuments') {
          this.uploadedSelectAll = false;
        } else if (type == 'generatedDocuments') {
          this.generatedDocSelectAll = false;
        }
      } else {
          var is_checked_all = 1;
          documentArr.map(docs => {
            if (this.selected_documents[docs.id] == false || this.selected_documents[docs.id] == 'undefined') {
              is_checked_all = 0;
              return;
            }
          });
          if (is_checked_all == 1) {
            if (type == 'documents') {
              this.documentSelectAll = true;
            } else if (type == 'uploadedDocuments') {
              this.uploadedSelectAll = true;
            } else if (type == 'generatedDocuments') {
              this.generatedDocSelectAll = true;
            }
          } else {
             if (type == 'documents') {
              this.documentSelectAll = false;
            } else if (type == 'uploadedDocuments') {
              this.uploadedSelectAll = false;
            } else if (type == 'generatedDocuments') {
              this.generatedDocSelectAll = false;
            }
          }
      }
    },
    checkCurrentTab(activeTab){
      if (activeTab === 'signed-in-progress') {
        this.getNotSignedEnvelopes();
      };
    },
    showDialogPopup(title, message) {
        this.error_dialog.title = title;
        this.error_dialog.content = message;
        this.error_dialog.show = true;
    },
    preventNav(event) {
        if (!this.isEditing) return;
        event.preventDefault();
        event.returnValue = '';
    },
    async getDocuments(){
      this.isEditing = true;
      let response = await this.$store.dispatch('fetch_doc_uploaded', {application_id: this.$route.params.id, showDeleted: true});
      this.isEditing = false;
      window.removeEventListener('beforeunload', this.preventNav);
    },
    async editDocumentType (document) {
      if (!document.document_type) {
        this.showErrorDialog("Please select a Document Type", "Document Type is required");
        return false;
      }

      await axios.post(
        "/api/v1/application/broker_edit_document_type",
        {
          document_type_name: document.document_type,
          application_id: this.application.loan.id,
          document_id: document.id,
        }
      ).then(function (response) {
        return true;
      }).catch((err) => {
        console.log(err);
        this.showErrorDialog("document type change failed", err.response.data);
        return false;
      });
    },
    async decline(document) {
      const res = await this.showNotification(
          "Warning!",
          "Are you sure want to delete this file?",
          "Delete",
          "Cancel"
      );
      if(res) {
        this.loading = true;
        this.stage = this.application.loan.status.stage;
        this.status = this.application.loan.status.status;
        if (this.userHasPermission('Accept/Decline Documents')) {
          await this.$store.dispatch('decline_document', {
              uploadedDocuments: document.id,
              applicationId: this.$route.params.id,
            })
          await this.$store.dispatch('fetch_doc_uploaded', { application_id: this.$route.params.id, showDeleted: true });
        } else {
          this.showDialogPopup(
              "",
              "<p>Your Application is in the final stages of settlement and you dont have privileges to soft delete this document at this stage<p>" +
              "Please contact Compliance for Further actions."
            );
            return
        }
      }
    },
    async getEnvelopesList(completed = 0) {
      try {
        const response = await axios.get(
          "/api/v1/docusign/get_envelope_list",
          {
            params: {
              application_id: this.application.loan.id
            }
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error retrieving envelopes:", error);
      }
    },
    async getNotSignedEnvelopes() {
      try {
          let allEnvelopes = await this.getEnvelopesList();
          // No including ones with status completed - "Docusign - Signed"
          let filteredEnvelopes = Object.values(allEnvelopes).filter(envelope => envelope.status !== "completed");
          this.envelopesProgressItems = filteredEnvelopes.map((envelope, index) => ({ ...envelope, id: index }));
      } catch (error) {
          console.error("Error filtering envelopes in progress:", error);
      }
    },
    loadmessage(message) {
          this.alertMessage = true;
          this.message = message;
          this.loading = false;
    },
    async save_verify() {
      try {
        this.sending_email = true;
        let application = await this.$store.dispatch('fetch_modify_doc_uploaded_verify', {
          uploadedDocuments: this.uploadedDocumentsWithoutBankStatement,
          applicationId: this.$route.params.id
        });
        this.sending_email = false;
      } catch (error) {
        console.error('update document request verified failed');
        console.error(error);
      }
    },

    async save_verify_bankstatement() {
      try {
        this.sending_email = true;
        let application = await this.$store.dispatch('fetch_modify_doc_uploaded_verify', {
          uploadedDocuments: this.uploadedDocumentsBankStatement,
          applicationId: this.$route.params.id
        });
        this.sending_email = false;
      } catch (error){
        console.error('update document request verified failed');
        console.error(error);
      }
    },

    async generateDocument() {
      let payload = {
        application: this.application,
        show_all_documents: true,
      }

      try {
        let response = await this.$store.dispatch('generate_document', payload);

        // popup errors if manually generate documents have errors
        if (response.data.validate_errors.length > 0) {
          this.error_dialog.title = 'failed to generate the document';
          this.error_dialog.content = response.data.validate_errors.map(function (value) {
            return value.message;
          }).toString().replace(/,/g, '<br>'); // use next line to display each error.
          this.error_dialog.show = true;
        }
      } catch (error) {
        console.error(error.response.data);
        this.error_dialog.title = 'failed to generate the document';
        this.error_dialog.content = error.response.data;
        this.error_dialog.show = true;
      }
    },

    async submit_docusign() {
      this.sending_document = true;
      let payload = {
        application: this.application,
        document_ids: this.selected_documents,
      }

      try {
        let response = await this.$store.dispatch('send_document_to_docusign', payload);
        this.showSuccessDialog('Documents sent to Docusign successfully');
      } catch (e) {
        console.error('failed to send the document to docusign');
        console.error(e);
        // the error returned a error message details from action.js
        this.showErrorDialog('failed to send the document to docusign', e.response.data);
      }
      finally {
        this.generateDocument();
        this.selected_documents = {};
      }
      this.sending_document = false;
    },

    async submit_email_customer() {
      this.sending_document = true;
      let payload = {
        application: this.application,
        document_ids: this.selected_documents,
      }

      try {
        let response = await this.$store.dispatch('send_email_to_customer', payload);
        this.showSuccessDialog('Send the documents to client successfully');
      } catch (e) {
        console.error('failed to send the document to docusign');
        console.error(e);
        this.showErrorDialog('failed to send email','failed to send the document to client by email' );
      }
      finally {
        this.selected_documents = {};
      }
      this.sending_document = false;
    },

    showNotification(title, message, confirmText, cancelText = null) {
      return this.$modal.show(ConfirmDialog, {
        title,
        message,
        confirmText,
        cancelText
      })
    },

    async submit_email_lender() {
      // TODO: Allow selection of lender to mail. Currently will only try to submit documents
      // to most recently created submission
      this.sending_document = true;
      let payload = {
        application: this.application,
        document_ids: this.selected_documents,
      }
      try {
        let response = await this.$store.dispatch('send_email_to_lender', payload);
        this.showSuccessDialog('Send the documents to lender successfully');
      } catch (e) {
        console.error('failed to send the document to lender by email');
        console.error(e);
        this.showErrorDialog('failed to send email', 'failed to send the document to lender by email');
      }
      finally {
        this.selected_documents = {};
      }
      this.sending_document = false;
    },

    async download_as_zip() {
      this.sending_document = true;
      let payload = {
        application : this.application,
        document_ids : this.selected_documents,
      }
      try {
        let response = await this.$store.dispatch('download_as_zip', payload);
        window.location.href = response;
        this.showSuccessDialog('Zip file downloaded successfully');
        let deleteZip = await this.$store.dispatch('delete_temp_zip', payload);
      } catch (e) {
        console.error('failed to download the Zip file');
        console.error(e);
        // the error returned a error message details from action.js
        this.showErrorDialog('failed to download the Zip file', e.response.data);
      }
      finally {
        this.selected_documents = {};
      }
      this.sending_document = false;
    },

    showErrorDialog(title, message) {
      this.error_dialog.show = true;
      this.error_dialog.title = title;
      this.error_dialog.content = message;
    },

    showSuccessDialog(message) {
      this.snackbar.show = true;
      this.snackbar.icon = "done";
      this.snackbar.content = message;
    },
  },

  computed: {
    ...mapGetters([
      'options',
      "docTemplates",
      "application",
      'application_status',
      'uploadedDocuments',
      'uploadedDocumentsWithoutBankStatement',
      'uploadedDocumentsBankStatement',
      'deletedDocuments',
      'signedDocuments',
      'generatedDocuments',
      'userHasPermission',
      'userHasAppPermission',
      'user',
    ]),

    applicant() {
      if (this.application_status.loaded) {
        return this.application.applicants[0];
      }
      return;
    },

    download_permission() {
      if (this.application_status.loaded) {
        return this.userHasAppPermission('view-document');
      }
      return false;
    },

    update_doc_type_permission() {
      if (this.application_status.loaded) {
        return this.userHasAppPermission('update-document-type');
      }
      return false;
    },

    hasPreviousSubmission() {
      // check if there is no previous submission
      if (this.application_status.loaded) {
        return this.application.loan.submission.previous.length > 0
      }
      return false;
    },

    enableDocusignBasedOnRole() {
      const allowRoles = ['super-admin', 'Compliance Officer'];
      return allowRoles.some( role => this.user.primary_roles.includes(role));
    }
  },
  filters:{
    ...filters
  },
  async beforeCreate() {
    const params = {
      types: [
        'document_types',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
}
</script>
<style lang="scss" scoped>
.document_table {
    table {
        td {
            text-align: center;
        }
    }
    .v-data-footer__select {
        display: none;
    }
}
</style>
<style scoped>

.md-ripple > span {
  position: relative;
}

a.disabled {
  opacity: 0.5;
}

.loading_icon_position {
  top: 10px;
  position: relative;
  left: 10px;
}

.upload-link-right {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.md-alignment-right {
  text-align: right;
}

.wrapper_no_width {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  /* width: 40vw; */
  height: auto;
  margin-bottom: 20px;
  padding: 30px;

  .md-table {
    height: 20vh;
  }

  .md-dialog-actions {
    align-self: end;
    padding-right: 30px;
  }

  .md-dialog-actions.resend {
    padding-top: 30px;
    padding-bottom: 0px;
  }

  .view_histroy_dialog {
    align-self: start;
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}

.wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 40vw;
  height: auto;
  margin-bottom: 20px;
  padding: 30px;

  .md-table {
    height: 20vh;
  }

  .md-dialog-actions {
    align-self: end;
    padding-right: 30px;
  }

  .md-dialog-actions.resend {
    padding-top: 30px;
    padding-bottom: 0px;
  }

  .void_envelope_dialog {
    align-self: start;
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}

</style>
